import { useContext, useEffect, useMemo } from 'react';
import { modalContext } from "../contexts/modalContext.js";

/**
 * This hook register new action at the ModalProvider
 * The provider itself is added to the Modal component
 * The actions will be rendered in the ModalFooter component (has to be added manually)
 * @param actions
 * @param deps
 */
export const useModalActions = ({
  actions = []
}, deps) => {
  const {
    setActions
  } = useContext(modalContext);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedActions = useMemo(() => actions, deps);
  useEffect(() => {
    setActions(memoizedActions);
  }, [memoizedActions, setActions]);
};